import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/Assets/images/loader-80x80.gif';
const _withScopeId = n => (_pushScopeId("data-v-7a2a2a18"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "loader-container"
};
const _hoisted_2 = {
  class: "card-body loader-body"
};
const _hoisted_3 = {
  class: "loader-title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loader"
}, [/*#__PURE__*/_createElementVNode("img", {
  id: "loader",
  src: _imports_0,
  alt: "Loader"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("platform.general.loading")), 1)]), _hoisted_4])]);
}